import React from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import "../css/privacy.scss";

function Privacy() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="privacy">
      <Header />
      <main className="privacy-main">
        <div className="page-header">
          <div className="page-header-inner">
            <div className="breadcrumb">
              <Link to="/" onClick={toTop}>Legal</Link>
            </div>
            <h1 className="page-title">Privacy Notice</h1>
          </div>
        </div>
        <div className="page-content">
          <p className="last-updated">Last Update: September 22nd, 2023</p>
          <div className="customer-service-content-inner">
            <div className="customer-service-body">
              <p>
                This Privacy Notice describes how MillerKnoll, Inc. and our
                brands and subsidiaries (collectively, “MillerKnoll,” “we,”
                “us,” or “our”) collect, use, and share information about you.
                This Privacy Notice applies to information we collect when you
                use our websites, mobile applications, and other online products
                and services that link to this Privacy Notice (collectively, the
                “Services”), shop in our stores, communicate with us, or
                otherwise interact with us. Please note that we may provide
                different or additional notices of our privacy practices with
_                respect to certain brands, which may supplement or clarify our
                privacy practices or provide you with additional choices about
                your information.
              </p>
              <p>
                We may change this Privacy Notice from time to time. If we make
                changes, we will notify you by revising the date at the top of
                this notice. In some cases, we may provide you with additional
                notice (such as by adding a statement to our website homepage or
                sending you a notification). We encourage you to review this
                Privacy Notice regularly to stay informed about our information
                practices and the choices available to you.
              </p>
              <h3>Collection of Information</h3>
              <p>
                The types of information we collect depend on the nature of your
                interaction with us. We collect information you provide directly
                to us. For example, we collect information when you create an
                account, fill out a form, make a purchase, or communicate with
                us. The types of information we may collect include your name,
                email address, postal address, phone number, payment
                information, and any other information you choose to provide.
              </p>
              <h3>Use of Information</h3>
              <p>
                We use the information we collect to provide, maintain, and
                improve our Services. We may also use the information we collect
                to:
              </p>
              <ul>
                <li>
                  Send you technical notices, updates, security alerts, and
                  support and administrative messages;
                </li>
                <li>
                  Respond to your comments, questions, and requests and provide
                  customer service;
                </li>
                <li>
                  Communicate with you about products, services, offers,
                  promotions, rewards, and events offered by MillerKnoll and
                  others, and provide news and information we think will be of
                  interest to you;
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Privacy;
